import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { MatDialogRef } from '@angular/material';
import { MobileUser } from '../../../@core/models/MobileUser';
import { Subscription } from 'rxjs';
import { SectorService } from '../../../@core/services/sector.service';
import { RouteService } from '../../../@core/services/route.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';

@Component({
  selector: 'ngx-user-preferences-dialog',
  templateUrl: './user-preferences-dialog.component.html',
  styleUrls: ['./user-preferences-dialog.component.scss']
})
export class UserPreferencesDialogComponent implements OnInit, OnDestroy {
  currentUser: MobileUser;
  sub: Subscription;
  checkedPUDO: boolean;
  checkedRoute: boolean;
  preferences: FormGroup;

  constructor(
    public authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<UserPreferencesDialogComponent>,
    public sectorService: SectorService,
    public routeService: RouteService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.sub = this.authenticationService.currentUser.subscribe((res) => {
      if (res) {
        this.currentUser = res;
        this.fillForm();
      }
    });
  }

  createForm() {
    this.preferences = this.fb.group({
      'email': ['', [Validators.required]],
      'name': ['', [Validators.required]],
      'firstname': ['', [Validators.required]],
      passwords: this.fb.group({
        password: [''],
        confirm_password: ['']
      }, { validator: this.confirmPassword })
    });
  }

  fillForm() {
    this.preferences.setValue({
      firstname: this.currentUser.firstname,
      name: this.currentUser.Name,
      email: this.currentUser.Email,
      passwords: {
        password: '',
        confirm_password: ''
      }
    });
  }

  get name() {
    return this.preferences.get('name') as FormControl;
  }

  confirmPassword(c: AbstractControl): { invalid: boolean } {
    if (c.get('password').value !== c.get('confirm_password').value) {
      return { invalid: true };
    }
  }

  public onClickPudoDealerSelection() {
    //
  }

  onSubmit(value): void {
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
